module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[18]139.0d10bec.woff2";